import { Image, Platform, Pressable, StyleSheet, Text, View, useWindowDimensions } from 'react-native';
import { RabblHomeButton } from '@/components/RabblHomeButton';
import { useRouter } from 'expo-router';

const styles = StyleSheet.create({
  backButtonWrapper: {
    ...Platform.select({
      ios: {
        paddingLeft: 10,
        paddingRight: 5,
      },
      android: {
        paddingLeft: 10,
        paddingRight: 5,
      },
      web: {
        paddingLeft: 20,
        paddingRight: 5,
      },
    }),
  },
  backButtonWrapperExtraPadding: {
    ...Platform.select({
      ios: {
        paddingLeft: 20,
        paddingRight: 10,
      },
      android: {
        paddingLeft: 20,
        paddingRight: 10,
      },
      web: {
        paddingLeft: 20,
        paddingRight: 5,
      },
    }),
  },
  backButtonImage: {
    ...Platform.select({
      ios: {
        width: 24,
        height: 24,
      },
      android: {
        width: 24,
        height: 24,
      },
      web: {
        width: 24,
        height: 24,
      },
    }),
  },
  homeButtonWrapper: {
    ...Platform.select({
      ios: {
        paddingLeft: 10,
        paddingRight: 5,
      },
      android: {
        paddingLeft: 10,
        paddingRight: 5,
      },
      web: {
        paddingLeft: 20,
        paddingRight: 10,
      },
    }),
  },
  homeButtonWrapperExtraPadding: {
    ...Platform.select({
      ios: {
        paddingLeft: 20,
        paddingRight: 10,
      },
      android: {
        paddingLeft: 20,
        paddingRight: 10,
      },
      web: {
        paddingLeft: 20,
        paddingRight: 10,
      },
    }),
  },
});

interface HeaderLeftProps {
  forceNoBackButton?: boolean,
  extraPadding?: boolean,
};

const HIT_SLOP = { top: 10, bottom: 10, left: 30, right: 30 };

export const HeaderLeft = ({
  forceNoBackButton = false,
  extraPadding = false,
}: HeaderLeftProps) => {
  const router = useRouter();

  if (!forceNoBackButton && router.canGoBack()) {
    return (
      <View style={extraPadding ? styles.backButtonWrapperExtraPadding : styles.backButtonWrapper}>
        <Pressable
          onPress={router.back}
          hitSlop={HIT_SLOP}
        >
          <Image
            source={require("@/assets/images/iphoneback2.png")}
            style={styles.backButtonImage}
          />
        </Pressable>
      </View>
    );
  } else {
    return (
      <View style={extraPadding ? styles.homeButtonWrapperExtraPadding : styles.homeButtonWrapper}>
        <RabblHomeButton />
      </View>
    );
  }
};
